var _path, _line, _line2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "black",
    stroke: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6475 36.4466C12.5313 36.3837 12.3952 36.3674 12.268 36.4032L4.09047 38.7081C3.71445 38.814 3.3676 38.4672 3.47358 38.0912L5.7784 29.9137C5.81427 29.7865 5.79797 29.6504 5.73504 29.5341C4.39783 27.0637 3.68489 24.2891 3.68489 21.4134C3.68489 11.9785 11.3334 4.33008 20.7682 4.33008C30.2031 4.33008 37.8516 11.9785 37.8516 21.4134C37.8516 30.8483 30.2031 38.4967 20.7682 38.4967C17.8925 38.4967 15.1179 37.7838 12.6475 36.4466ZM13.3316 33.1821C13.2025 33.1045 13.0452 33.0892 12.9036 33.1406L7.84654 34.9732C7.44785 35.1176 7.06162 34.7314 7.2061 34.3327L9.03871 29.2757C9.09003 29.134 9.07477 28.9768 8.99716 28.8477L8.83064 28.5707C7.54199 26.4269 6.85156 23.973 6.85156 21.4137C6.85156 13.7291 13.0811 7.49962 20.7656 7.49962C28.4501 7.49962 34.6796 13.7291 34.6796 21.4137C34.6796 29.0982 28.4501 35.3277 20.7656 35.3277C18.2062 35.3277 15.7523 34.6373 13.6086 33.3486L13.3316 33.1821Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 14.332,
    y1: 18.5098,
    x2: 28.2079,
    y2: 18.5098,
    strokeWidth: 3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 14.332,
    y1: 25.502,
    x2: 24.3064,
    y2: 25.502,
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatting);
export default __webpack_public_path__ + "static/media/chatting.baacdf28.svg";
export { ForwardRef as ReactComponent };